module.exports = __webpack_public_path__ + "img/weather1.f547aa74.png";